import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Image } from "react-bootstrap";
import { iconHandOrange, iconQuizLP01, learnMore2 } from "../../lib/images";
import { HashLink } from "react-router-hash-link";
import "./Calendar.style.scss";
import { Trans, useTranslation } from "react-i18next";

function Calendar(props) {
  let isHome = props.isHome;
  let isPSC = props.isPSC;
  const { t } = useTranslation();
  return (
    <div>
      <Container id="calendar" className="calendar-section" fluid>
        <Row noGutters>
          <div className={isHome ? "title peach-color" : isPSC ? "top-margin-zero bottom-padding-zero title" : "title"}>
            <span className={isPSC ? "hide" : ""}>{t("save_these_important")}</span>
          </div>
          <div className="leader">
            <p>
              <Trans i18nKey="and_be_sure_to_check">
                <HashLink to="/#voter-status" smooth>
                  {" "}
                </HashLink>
              </Trans>
            </p>
          </div>
        </Row>
        <Row className="calendar-grid">
          <Col xs="12" xl="7" className="col-left">
            <div className="calendar_item">
              <div className="title_2">{t("PRIMARY ELECTION")}</div>
              <Container className="ctn-text-content-note" fluid>
                <Row className="text-content-note" noGutters>
                  <Col xs="6" sm="6" xl="7" className="text-content-note-step">
                    <Trans i18nKey="early_voting_starts">
                      <span class="language-customization-es"></span>
                    </Trans>
                  </Col>
                  <Col xs="1" xl="1" className="col-hand-orange">
                    <Image src={iconHandOrange} className="icon-hand-orange" />
                  </Col>
                  <Col xs="4" sm="5" xl="4" className="text-content-note-t">
                    <p>
                      <Trans i18nKey="apr_27_2026">
                        <span class="language-customization-es"></span>
                        <span class="line"></span>
                        <span class="line"></span>
                      </Trans>
                    </p>
                  </Col>
                </Row>
                <Row className="text-content-note" noGutters>
                  <Col xs="6" sm="6" xl="7" className="text-content-note-step">
                    <Trans i18nKey="last_day_to_request">
                      <span class="language-customization-es"></span>
                      <br />
                    </Trans>
                    <Trans i18nKey="a_vote_by_mail_ballot">
                      <span class="language-customization-es"></span>
                    </Trans>
                  </Col>
                  <Col xs="1" xl="1" className="col-hand-orange">
                    <Image src={iconHandOrange} className="icon-hand-orange" />
                  </Col>
                  <Col xs="4" sm="5" xl="4" className="text-content-note-t">
                    <p>
                      <Trans i18nKey="may_8_2026">
                        <span class="language-customization-es"></span>
                        <span class="line"></span>
                        <span class="line"></span>
                      </Trans>
                    </p>
                  </Col>
                </Row>
                <Row className="text-content-note" noGutters>
                  <Col xs="6" sm="6" xl="7" className="text-content-note-step">
                    <Trans i18nKey="early_voting_ends">
                      <span class="language-customization-es"></span>
                    </Trans>
                  </Col>
                  <Col xs="1" xl="1" className="col-hand-orange">
                    <Image src={iconHandOrange} className="icon-hand-orange" />
                  </Col>
                  <Col xs="4" sm="5" xl="4" className="text-content-note-t">
                    <p>
                      <Trans i18nKey="may_15_2026">
                        <span class="language-customization-es"></span>
                        <span class="line"></span>
                        <span class="line"></span>
                      </Trans>
                    </p>
                  </Col>
                </Row>
                <Row className="text-content-note" noGutters>
                  <Col xs="6" sm="6" xl="7" className="text-content-note-step">
                    <Trans i18nKey="election_day">
                      <span class="language-customization-es"></span>
                    </Trans>
                  </Col>
                  <Col xs="1" xl="1" className="col-hand-orange">
                    <Image src={iconHandOrange} className="icon-hand-orange" />
                  </Col>
                  <Col xs="4" sm="5" xl="4" className="text-content-note-t">
                    <p>
                      <Trans i18nKey="may_19_2026">
                        <span class="language-customization-es"></span>
                        <span class="line"></span>
                        <span class="line"></span>
                      </Trans>
                    </p>
                  </Col>
                </Row>
              </Container>
            </div>
            <div className="calendar_item">
              <div className="title_2">{t("GENERAL ELECTION")}</div>
              <Container className="ctn-text-content-note" fluid>
                <Row className="text-content-note" noGutters>
                  <Col xs="6" sm="6" xl="7" className="text-content-note-step">
                    <Trans i18nKey="early_voting_starts">
                      <span class="language-customization-es"></span>
                    </Trans>
                  </Col>
                  <Col xs="1" xl="1" className="col-hand-orange">
                    <Image src={iconHandOrange} className="icon-hand-orange" />
                  </Col>
                  <Col xs="4" sm="5" xl="4" className="text-content-note-t">
                    <p>
                      <Trans i18nKey="oct_13_2026">
                        <span class="language-customization-es"></span>
                        <span class="line"></span>
                        <span class="line"></span>
                      </Trans>
                    </p>
                  </Col>
                </Row>
                <Row className="text-content-note" noGutters>
                  <Col xs="6" sm="6" xl="7" className="text-content-note-step">
                    <Trans i18nKey="last_day_to_request">
                      <span class="language-customization-es"></span>
                      <br />
                    </Trans>
                    <Trans i18nKey="a_vote_by_mail_ballot">
                      <span class="language-customization-es"></span>
                    </Trans>
                  </Col>
                  <Col xs="1" xl="1" className="col-hand-orange">
                    <Image src={iconHandOrange} className="icon-hand-orange" />
                  </Col>
                  <Col xs="4" sm="5" xl="4" className="text-content-note-t">
                    <p>
                      <Trans i18nKey="oct_23_2026">
                        <span class="language-customization-es"></span>
                        <span class="line"></span>
                        <span class="line"></span>
                      </Trans>
                    </p>
                  </Col>
                </Row>
                <Row className="text-content-note" noGutters>
                  <Col xs="6" sm="6" xl="7" className="text-content-note-step">
                    <Trans i18nKey="early_voting_ends">
                      <span class="language-customization-es"></span>
                    </Trans>
                  </Col>
                  <Col xs="1" xl="1" className="col-hand-orange">
                    <Image src={iconHandOrange} className="icon-hand-orange" />
                  </Col>
                  <Col xs="4" sm="5" xl="4" className="text-content-note-t">
                    <p>
                      <Trans i18nKey="oct_30_2026">
                        <span class="language-customization-es"></span>
                        <span class="line"></span>
                        <span class="line"></span>
                      </Trans>
                    </p>
                  </Col>
                </Row>
                <Row className="text-content-note" noGutters>
                  <Col xs="6" sm="6" xl="7" className="text-content-note-step">
                    <Trans i18nKey="election_day">
                      <span class="language-customization-es"></span>
                    </Trans>
                  </Col>
                  <Col xs="1" xl="1" className="col-hand-orange">
                    <Image src={iconHandOrange} className="icon-hand-orange" />
                  </Col>
                  <Col xs="4" sm="5" xl="4" className="text-content-note-t">
                    <p>
                      <Trans i18nKey="nov_3_2026">
                        <span class="language-customization-es"></span>
                        <span class="line"></span>
                        <span class="line"></span>
                      </Trans>
                    </p>
                  </Col>
                </Row>
              </Container>
            </div>
          </Col>
          <Col xs="12" xl="5" className="col-right d-none d-xl-block">
            <Image src={isPSC ? learnMore2 : iconQuizLP01} />
          </Col>{" "}
        </Row>
      </Container>
    </div>
  );
}
export default Calendar;
